import {Injectable} from '@angular/core';
import {TabDefinition} from '../../components/tabs/tab-definition';
import {TabFactory} from '../../components/tabs/tab.factory';
import {WatchlistService} from '../../components/watchlist';
import {Tab} from '../../models/tab';
import {Dashboard, DashboardDefinition} from './dashboard';

@Injectable()
export class DashboardFactoryService {

    constructor(
        private watchlistService: WatchlistService,
        private tabFactory: TabFactory
    ) {}

    public createDashboardByDefinition(
        dashboardDef: DashboardDefinition,
        defaultDashboardDef?: DashboardDefinition
    ): Dashboard {
        const tabs = this.createTabsByDefinition(
            dashboardDef && dashboardDef.tabs,
            defaultDashboardDef && defaultDashboardDef.tabs
        );

        return {tabs, version: dashboardDef?.version};
    }

    public getDashboardDefinition(dashboard: Dashboard): DashboardDefinition {
        return {
            tabs:    dashboard.tabs.map(tab => this.tabFactory.getTabDefinition(tab)),
            version: dashboard.version
        };
    }

    private createTabsByDefinition(tabDefs: TabDefinition[], defaultTabDefs?: TabDefinition[]): Tab[] {
        const parseTabDef = (tabDef: TabDefinition) => {
            let tab: Tab;

            try {
                tab = this.tabFactory.createTabByDefinition(tabDef);
            } catch (error) {
                console.warn('[DashboardFactoryService] Invalid tab definition.', error);
            }

            return tab;
        };

        let tabs: Tab[] = (tabDefs || [])
            .map(parseTabDef)
            .filter(tab => !!tab);

        if (!tabs || !tabs.length) {
            tabs = (defaultTabDefs || []).map(parseTabDef);
        }

        return tabs;
    }

}
